// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-admin-js": () => import("./../../../src/pages/admin.js" /* webpackChunkName: "component---src-pages-admin-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-details-offer-js": () => import("./../../../src/templates/detailsOffer.js" /* webpackChunkName: "component---src-templates-details-offer-js" */),
  "component---src-templates-details-portfolio-js": () => import("./../../../src/templates/detailsPortfolio.js" /* webpackChunkName: "component---src-templates-details-portfolio-js" */)
}

